'use client';
import { FOOTER_QUERY } from '@/sanity/queries/footer';
import { client } from '@/sanity/lib/client';
import { useEffect, useState } from 'react';
import type { FooterData } from '../interfaces';
import { cleanStegaDataRecursively } from '@workspace/lib/stega-utils';

export const useFooter = (enabled = true) => {
  const [footerData, setFooterData] = useState<FooterData | undefined>(undefined);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (!enabled) {
      setLoading(false);
      return;
    }

    const fetchFooter = async () => {
      try {
        setLoading(true);
        const data = await client.fetch(FOOTER_QUERY);
        setFooterData(cleanStegaDataRecursively(data));
      } catch (err) {
        setError(err instanceof Error ? err.message : 'Failed to fetch footer data');
      } finally {
        setLoading(false);
      }
    };

    fetchFooter();
  }, [enabled]);

  return { footerData, loading, error };
};
